<template>
  <div>
    <!-- Filter -->
    <CRow>
      <div class="col-sm-12 col-xl-6">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Periode</label>
            <multiselect
              class="mulit-select"              
              placeholder="Pilih Periode"
              label="label"
              track-by="label"
              :show-labels="false"
              required
              v-model="periode"
              @select="changePeriode"
              :options="dataPeriode"
              :loading="loadingMultiSelect.isLoadingPeriode"
            ></multiselect>           
          </div>
        </div>
      <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label 
            for="" 
            class="font-weight-bold">
            Pilih Sertifikasi RPL
          </label>
          <multiselect
            class="mulit-select"
            label="nama_rpl"
            track-by="nama_rpl"
            placeholder="Pilih RPL"
            :show-labels="false"
            required
            v-model="kategoriRpl"
            @select="changeKategoriRpl"
            :options="dataKategoriRpl"
            :loading="loadingMultiSelect.isLoadingRpl"
          ></multiselect>
        </div>
      </div>
      <div class="col-sm-12 col-xl-12">
          <div style="float:right">
            <template v-if="role_status && role_status.status_export_excel">
            <button class="btn btn-warning mr-1 text-white" @click="resetFilter">Export Data</button>
            </template>
            <template v-else>
            <button class="btn btn-secondary mr-1 text-white" disabled>Export Data</button>
            </template>
            <button class="btn btn-info mr-1" @click="resetFilter">Reset Filter</button>
            <button class="btn btn-success mr-1" @click="filterData">Terapkan</button>
          </div>
        </div>
    </CRow>
    <br />
    <CRow>
      <div class="col-sm-12 col-xl-6">
          <label for="">Data Per Halaman</label>
        <div class="form-group">
          <CSelect
            class="float-left"
            laebl="Data Per Halaman"
            placeholder="Data Per Halaman"
            @change="changePageSizeDataPesertaRpl"
            :options="[10, 25, 100, 'Semua Data']"
          />
        </div>
      </div>
      <div class="col-sm-12 col-xl-6 ml-auto">
        <div class="form-group">
          <CInput 
            label="Pencarian"
            class="float-right" 
            placeholder="Cari Data .." 
            @keyup="searchMethods($event)"
          />
          <!-- v-model="searchDataPesertaRpl"  -->
        </div>
      </div>
    </CRow>
    <!-- filter -->
  </div>
</template>
<script>
import MasterRplService from '../../../services/rpl/master-rpl.service'
import PeriodeRplService from '../../../services/datamaster/periode-rpl.service'
import DataPesertaRplService from '../../../services/rpl/data-peserta-rpl.service';

export default {
  name: "FilterRpl",  
  props: [
    'searchData'
  ],
  data() {
    return {
      loadingMultiSelect : {
        isLoadingPeriode : true,
        isLoadingRpl : true,
      },
      formFilter : {
        periode: '',
        idSertifikasiRpl : '',
        status_pembayaran : '',
      },
      periode :'',
      dataPeriode : [],
      kategoriRpl: '',
      dataKategoriRpl: [],         
      searchField : '',  
      role_status: null
    };
  },
  mounted() {    
    this.getPeriode();
    this.roleData();
    // this.getKategoriRpl();
  },
  methods: {    
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    searchMethods(e) {
      this.$parent.syncSearch(e.target.value);
    },

    getPeriode() {
      this.loadingMultiSelect.isLoadingPeriode = true;
      PeriodeRplService.getPeriodeSelect()
        .then(response => {
          this.dataPeriode = response.data.data
          this.periode = this.dataPeriode.find(el => el.status === "1");      
          if(this.periode == undefined) {
            this.formFilter.periode = ''
            this.loadingMultiSelect.isLoadingPeriode = false;   
          } else {
            this.formFilter.periode = this.periode.value; 
            this.loadingMultiSelect.isLoadingPeriode = false;   
          }
          this.getKategoriRpl();
        })
        .catch(error => {          
          // comment console console.log(error)
          this.loadingMultiSelect.isLoadingPeriode = false;   
        })      
    },

    filterData() {
      this.$parent.filterData(this.formFilter);
    },

    resetFilter() {
      this.periode = '';
      this.kategoriRpl = '';            
    },  
    
    getKategoriRpl() {
      var vm = this;
      this.loadingMultiSelect.isLoadingRpl = true;      
      DataPesertaRplService.getKategoriPesertaRpl()
        .then(response => {
          // comment console console.log(response)
          this.dataKategoriRpl = response.data.data;
          this.kategoriRpl = this.dataKategoriRpl[0]
          this.formFilter.idSertifikasiRpl = this.kategoriRpl.id_sertifikasi_rpl;
          this.loadingMultiSelect.isLoadingRpl = false;
          this.$parent.filterData(this.formFilter);
        })
        .catch(error => {          
          // comment console console.log(error)
          this.loadingMultiSelect.isLoadingRpl = false;
        })
    },

    changePeriode(e) {      
      this.formFilter.periode = e.value
    },

    changeKategoriRpl(value) {      
      this.formFilter.idSertifikasiRpl = value.id_sertifikasi_rpl        
    },

    changePageSizeDataPesertaRpl(e) {      
      this.$parent.changePageSizeDataPesertaRpl(e);
    },                           
  },
  computed: {},
};
</script>